export default "__VITE_ASSET__BC5br2Sa__"